import Helpers from './Helpers'
import Reveal from '../modules/Reveal'
import XhrPromise from 'xhr-promise'


// Request
const sendEmailToNewsletterSignUp = (e, signUpContainer, formObject) => {
    e.preventDefault();

    const xhr = new XhrPromise();
    const { emailField, formUI, errorUI, successUI } = formObject;
    const emailAddress = emailField.value;

    xhr.send({
        url: '/ajax/newsletter.aspx',
        method: 'POST',
        data: `email=${emailAddress}`
    })
    .then((response) => {
        return response.responseText.length > 0 ? JSON.parse(response.responseText) : {};
    })
    .then((data) => {
        formUI.setAttribute('aria-hidden', 'true');
        errorUI.setAttribute('aria-hidden', data.error ? 'false' : 'true');
        successUI.setAttribute('aria-hidden', data.error ? 'true' : 'false');

        if (!data.error) {
            setTimeout(() => new Helpers(signUpContainer).removeClass('modal--active'), 6000);
        }
    });
};

// Create Sign Up Object
const createSignUpFormObject = container => {
    return {
        formUI: container.getElementsByClassName('sign-up')[0],
        successUI: container.getElementsByClassName('newsletter__success')[0],
        errorUI: container.getElementsByClassName('newsletter__error')[0],
        submitButton: container.getElementsByTagName('button')[0],
        emailField: container.getElementsByTagName('input')[0],
    };
};

// Footer sign up
const newsletterFooterSignUp = document.getElementById('footer-newsletter-sign-up');
if (newsletterFooterSignUp) {
    const formObject = createSignUpFormObject(newsletterFooterSignUp);
    new Helpers(formObject.formUI.getElementsByTagName('form')).eventListener((e) => {
        sendEmailToNewsletterSignUp(e, newsletterFooterSignUp, formObject);
    }, 'submit');
}

// Modal sign Up
const newsletterModalSignUp = document.getElementById('modal-newsletter-sign-up');
if (newsletterModalSignUp) {
    const formObject = createSignUpFormObject(newsletterModalSignUp);
    new Helpers(formObject.formUI.getElementsByTagName('form')).eventListener((e) => {
        sendEmailToNewsletterSignUp(e, newsletterModalSignUp, formObject);
    }, 'submit');
}



// Get the query parameters and check if we want to load the page with the newsletter sign up modal open
if (newsletterModalSignUp) {
    const queryParams = new URLSearchParams(window.location.search);
    const paramName = 'newsletter';
    if (newsletterModalSignUp && queryParams.has(paramName)) {
        const activeClass = 'modal--active';
        new Reveal(newsletterModalSignUp).show(activeClass);
    }
}
